import { Button, CloseButton, Flex, Heading } from "@chakra-ui/react";
import { FC } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useAddTaskMutation } from "../../hooks/api/karl-farm/useAddTaskMutation";
import { useTranslation } from "../../i18n/useTranslation";
import { addDateAndTime } from "../../utils/dates";
import { DrawerContent, DrawerFooter, DrawerHeader } from "../Drawer";
import { TaskForm, TaskFormData } from "./TaskForm";

type AddTaskDrawerProps = {
  start: Date | null;
  onClose: () => void;
};
export const AddTaskDrawer: FC<AddTaskDrawerProps> = ({ start, onClose }) => {
  const { t } = useTranslation();

  const methods = useForm<TaskFormData>({
    shouldUnregister: true,
  });
  const { handleSubmit } = methods;

  const { mutate } = useAddTaskMutation();

  const handleValidSubmit: SubmitHandler<TaskFormData> = (formData) => {
    const {
      title,
      task,
      crop,
      tillingDepth,
      dropSize,
      fields,
      startDate,
      startTime,
      duration,
      users,
      machines,
      notes,
    } = formData;

    const localizedStartDateTime = addDateAndTime(
      startDate,
      parseInt(startTime)
    );
    const startDateTimeEpochSeconds = Math.floor(
      localizedStartDateTime.getTime() / 1000
    );

    mutate({
      attributes: {
        title,
        task,
        crop,
        tilling_depth: tillingDepth,
        drop_size: dropSize,
        notes,
      },
      time: {
        start: startDateTimeEpochSeconds,
        duration: parseInt(duration),
      },
      fields: fields.map((fieldId) => ({ id: fieldId })),
      users: users.map((userId) => ({ id: userId })),
      machines: machines.map((machineId) => ({ id: machineId })),
    });

    onClose();
  };

  return (
    <>
      <DrawerHeader>
        <Heading as="h2" size="md">
          {t("component.AddTaskDrawer.heading")}
        </Heading>
        <CloseButton onClick={onClose} />
      </DrawerHeader>

      <DrawerContent>
        <TaskForm start={start || undefined} formMethods={methods} />
      </DrawerContent>

      <DrawerFooter>
        <Flex gap="10px" grow={1}>
          <Button variant="outline" onClick={onClose}>
            {t("component.AddTaskDrawer.buttons.cancel")}
          </Button>
          <Button onClick={handleSubmit(handleValidSubmit)}>
            {t("component.AddTaskDrawer.buttons.add")}
          </Button>
        </Flex>
      </DrawerFooter>
    </>
  );
};
